<template>
    <v-card v-ripple="false">
        <div class="games-card" :class="class_list + ((readyPlay[userId] == 1 && game.type == 1) ? ' sleep' : ((readyPlay[userId] == 2 && game.type == 1 || game.type == 3 && matches.action== 'start') ? ' played' : ''))">
            <div class="user-list" :class="item_game">
                <div  class="block-played">{{__('Now playing')}}</div>
                <div  class="block-sleeped">{{__('Dormant')}}</div>
                <div class="button-sleepped">
                    <svg v-if="matches.password" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.8001 8.19996H2.60001C1.71635 8.19996 1 8.91631 1 9.79997V15.4C1 16.2837 1.71635 17 2.60001 17H13.8001C14.6837 17 15.4001 16.2837 15.4001 15.4V9.79997C15.4001 8.91631 14.6837 8.19996 13.8001 8.19996Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.19982 8.20003V5.00002C4.19982 3.93915 4.62125 2.92173 5.3714 2.17158C6.12155 1.42143 7.13897 1 8.19984 1C9.26071 1 10.2781 1.42143 11.0283 2.17158C11.7784 2.92173 12.1999 3.93915 12.1999 5.00002V8.20003" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <svg v-else width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9661 10.4415C12.993 12.3111 7.62308 15.4747 4.87589 16.4904C4.43742 16.6521 3.31959 16.9947 3.07871 16.9994C2.56716 17.0137 2.07456 16.7616 1.83638 16.3572C1.74435 16.2002 1.4737 15.175 1.38708 14.7183C1.12996 13.3292 0.997334 11.1717 1.00004 9.00241C0.997334 6.72605 1.14078 4.46633 1.42768 3.09148C1.50347 2.72041 1.72541 1.86647 1.79037 1.72851C1.91216 1.47162 2.1341 1.26943 2.40206 1.14336C2.60776 1.04584 2.84323 0.993509 3.07871 1.00065C3.31959 1.0054 4.29938 1.30749 4.635 1.42404C7.28205 2.32793 12.882 5.60571 14.939 7.53241C15.1231 7.70605 15.6292 8.17227 15.7131 8.26741C15.9053 8.48149 16 8.74076 16 9.00241C16 9.24504 15.9161 9.49241 15.7429 9.69936C15.6536 9.8064 15.1366 10.2821 14.9661 10.4415Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <p>{{__('Play now')}}</p>
                </div>
                <div class="button-played">
                    <svg v-if="matches.password" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.8001 8.19996H2.60001C1.71635 8.19996 1 8.91631 1 9.79997V15.4C1 16.2837 1.71635 17 2.60001 17H13.8001C14.6837 17 15.4001 16.2837 15.4001 15.4V9.79997C15.4001 8.91631 14.6837 8.19996 13.8001 8.19996Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.19982 8.20003V5.00002C4.19982 3.93915 4.62125 2.92173 5.3714 2.17158C6.12155 1.42143 7.13897 1 8.19984 1C9.26071 1 10.2781 1.42143 11.0283 2.17158C11.7784 2.92173 12.1999 3.93915 12.1999 5.00002V8.20003" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <svg v-else width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9661 10.4415C12.993 12.3111 7.62308 15.4747 4.87589 16.4904C4.43742 16.6521 3.31959 16.9947 3.07871 16.9994C2.56716 17.0137 2.07456 16.7616 1.83638 16.3572C1.74435 16.2002 1.4737 15.175 1.38708 14.7183C1.12996 13.3292 0.997334 11.1717 1.00004 9.00241C0.997334 6.72605 1.14078 4.46633 1.42768 3.09148C1.50347 2.72041 1.72541 1.86647 1.79037 1.72851C1.91216 1.47162 2.1341 1.26943 2.40206 1.14336C2.60776 1.04584 2.84323 0.993509 3.07871 1.00065C3.31959 1.0054 4.29938 1.30749 4.635 1.42404C7.28205 2.32793 12.882 5.60571 14.939 7.53241C15.1231 7.70605 15.6292 8.17227 15.7131 8.26741C15.9053 8.48149 16 8.74076 16 9.00241C16 9.24504 15.9161 9.49241 15.7429 9.69936C15.6536 9.8064 15.1366 10.2821 14.9661 10.4415Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <p>{{__('Play now')}}</p>
                </div>

              <v-list color="transparent" class="pa-0" v-if="matches.user && game.type == 1 || matches.user && game.type == 3 && matches.max_players == 2">
                  <v-list-item class="pa-0">
                        <div class="block-img" :class="(matches.user.pro) ? 'user-pro-img' : ''">
                            <router-link :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >
                                <div class="wrap-img">
                                    <!--                    <img :src="'/assets/users/'+((matches.user.photo) ? matches.user.photo : 'a-default.svg')"/>-->

                                    <img v-if="matches.user.photo && typeof matches.user.photo == 'object'" :src="matches.user.photo[40]"/>
                                    <img v-else-if="matches.user.photo" :src="matches.user.photo"/>
                                    <span v-else class="photo" :style="{'background': matches.user.bg_color}">{{matches.user.name.substr(0,1)}}</span>
                                </div>
                                <div v-if="now_date < date" class="online"></div>
                            </router-link>
                        </div>
                        <v-list-item-content class="person-info pa-0">
                            <v-list-item-title>
                                <router-link :class="(matches.user.pro) ? 'user-pro' : ''" :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >
                                    {{matches.user.name+" "+((matches.user.last_name) ? matches.user.last_name : '')}}
                                </router-link>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div class="block-raiting">
                                    <img class="ml-0 mr-1" height="12px" src="/dist/images/frontend/fire.svg" alt />
                                    <span style="color: #F6A401">{{matches.user.rating_points}}</span>
                                </div>
                                <span style="color: #96AFD1">
                                   <img width="14" :src="matches.user.location_img" />
                                   {{$getLocation(matches.user.location)}}
                                </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
              <v-list color="transparent" class="pa-0" v-else-if="(game.type == 2 || game.type == 3 || game.type == 4) && matches.max_players == 2">
                 <v-list-item class="pa-0">
                        <div class="block-img-game">
                            <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                                <div class="wrap-img-game">
                                    <img v-if="typeof game.logo == 'object'" :src="game.logo[100]">
                                    <img v-else :src="game.logo">
                                </div>
                            </router-link>
                        </div>
                        <v-list-item-content class="person-info pa-0">
                            <v-list-item-title>
                                <span>{{matches.name}}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div class="block-info-game">
                                    <div class="block-info-game__players">
                                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.42566 2.80248C9.42566 4.17313 8.33297 5.27217 6.97024 5.27217C5.60752 5.27217 4.51483 4.17313 4.51483 2.80248C4.51483 1.4313 5.60752 0.333313 6.97024 0.333313C8.33297 0.333313 9.42566 1.4313 9.42566 2.80248ZM6.97025 9.66665C4.96873 9.66665 3.2597 9.34934 3.2597 8.08008C3.2597 6.8103 4.95776 6.48143 6.97025 6.48143C8.97178 6.48143 10.6808 6.79874 10.6808 8.06852C10.6808 9.33778 8.98275 9.66665 6.97025 9.66665ZM10.475 2.84704C10.475 3.54576 10.2665 4.19667 9.90092 4.73779C9.86332 4.79347 9.89675 4.8686 9.96308 4.88016C10.0545 4.89592 10.149 4.90485 10.2451 4.90747C11.2036 4.93269 12.0638 4.31225 12.3015 3.37817C12.6535 1.99071 11.6199 0.745095 10.3036 0.745095C10.1605 0.745095 10.0237 0.760331 9.89048 0.787649C9.8722 0.791852 9.85287 0.800258 9.84242 0.816544C9.82989 0.836507 9.83929 0.8633 9.85183 0.880637C10.2472 1.43804 10.475 2.11785 10.475 2.84704ZM12.0623 5.88232C12.7063 6.00893 13.1299 6.26741 13.3054 6.64304C13.4537 6.95142 13.4537 7.30918 13.3054 7.61704C13.0369 8.19966 12.1714 8.38668 11.8351 8.43502C11.7656 8.44552 11.7097 8.38511 11.717 8.31524C11.8889 6.70082 10.522 5.93538 10.1683 5.75939C10.1532 5.75151 10.1501 5.73943 10.1516 5.73207C10.1527 5.72682 10.1589 5.71841 10.1704 5.71684C10.9356 5.70265 11.7583 5.80772 12.0623 5.88232ZM3.75495 4.90741C3.85106 4.90478 3.94508 4.89638 4.037 4.88009C4.10334 4.86853 4.13677 4.79341 4.09916 4.73772C3.73354 4.19661 3.52513 3.54569 3.52513 2.84697C3.52513 2.11778 3.75286 1.43797 4.14826 0.880572C4.16079 0.863235 4.16967 0.836442 4.15766 0.816479C4.14721 0.800718 4.12736 0.791787 4.10961 0.787584C3.97589 0.760266 3.83904 0.745031 3.69593 0.745031C2.37969 0.745031 1.34602 1.99064 1.69858 3.3781C1.93624 4.31218 2.7965 4.93263 3.75495 4.90741ZM3.84819 5.73175C3.84976 5.73963 3.84663 5.75119 3.832 5.7596C3.47787 5.93559 2.11096 6.70103 2.28281 8.31492C2.29012 8.38532 2.23475 8.44521 2.16528 8.43523C1.82891 8.38689 0.96343 8.19987 0.694959 7.61725C0.546098 7.30887 0.546098 6.95163 0.694959 6.64324C0.870457 6.26762 1.29354 6.00914 1.93755 5.88201C2.24207 5.80793 3.06419 5.70286 3.82991 5.71704C3.8414 5.71862 3.84715 5.72703 3.84819 5.73175Z" fill="#6886AF"/>
                                        </svg>
                                        <span>{{matches.user_play}}</span>/{{matches.max_players}}
                                    </div>
<!--                                    <span class="circle"></span>-->
<!--                                    <p class="game-info-game__created">{{__('Created by')}}-->
<!--                                        <router-link v-if="game.developer.id == matches.user_id" :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >-->
<!--                                            {{__('Admin')}}-->
<!--                                        </router-link>-->
<!--                                        <router-link v-else :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >-->
<!--                                            {{__('User')}}-->
<!--                                        </router-link>-->
<!--                                    </p>-->
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-list color="transparent" v-else class="pa-0">
                    <v-list-item class="pa-0">
                        <div class="block-img-game">
                            <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                                <div class="wrap-img-game">
                                    <img v-if="typeof game.logo == 'object'" :src="game.logo[100]">
                                    <img v-else :src="game.logo">
                                </div>
                            </router-link>
                        </div>
                        <v-list-item-content class="person-info pa-0">
                            <v-list-item-title>
                                <router-link v-if="game.type == 1" :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                                    {{game_array.name}}
                                </router-link>
                                <span v-else>{{matches.name}}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div v-if="game.type == 2 || game.type == 3 || game.type == 4 && matches.max_players > 2" class="block-info-game">
                                    <div class="block-info-game__players">
                                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.42566 2.80248C9.42566 4.17313 8.33297 5.27217 6.97024 5.27217C5.60752 5.27217 4.51483 4.17313 4.51483 2.80248C4.51483 1.4313 5.60752 0.333313 6.97024 0.333313C8.33297 0.333313 9.42566 1.4313 9.42566 2.80248ZM6.97025 9.66665C4.96873 9.66665 3.2597 9.34934 3.2597 8.08008C3.2597 6.8103 4.95776 6.48143 6.97025 6.48143C8.97178 6.48143 10.6808 6.79874 10.6808 8.06852C10.6808 9.33778 8.98275 9.66665 6.97025 9.66665ZM10.475 2.84704C10.475 3.54576 10.2665 4.19667 9.90092 4.73779C9.86332 4.79347 9.89675 4.8686 9.96308 4.88016C10.0545 4.89592 10.149 4.90485 10.2451 4.90747C11.2036 4.93269 12.0638 4.31225 12.3015 3.37817C12.6535 1.99071 11.6199 0.745095 10.3036 0.745095C10.1605 0.745095 10.0237 0.760331 9.89048 0.787649C9.8722 0.791852 9.85287 0.800258 9.84242 0.816544C9.82989 0.836507 9.83929 0.8633 9.85183 0.880637C10.2472 1.43804 10.475 2.11785 10.475 2.84704ZM12.0623 5.88232C12.7063 6.00893 13.1299 6.26741 13.3054 6.64304C13.4537 6.95142 13.4537 7.30918 13.3054 7.61704C13.0369 8.19966 12.1714 8.38668 11.8351 8.43502C11.7656 8.44552 11.7097 8.38511 11.717 8.31524C11.8889 6.70082 10.522 5.93538 10.1683 5.75939C10.1532 5.75151 10.1501 5.73943 10.1516 5.73207C10.1527 5.72682 10.1589 5.71841 10.1704 5.71684C10.9356 5.70265 11.7583 5.80772 12.0623 5.88232ZM3.75495 4.90741C3.85106 4.90478 3.94508 4.89638 4.037 4.88009C4.10334 4.86853 4.13677 4.79341 4.09916 4.73772C3.73354 4.19661 3.52513 3.54569 3.52513 2.84697C3.52513 2.11778 3.75286 1.43797 4.14826 0.880572C4.16079 0.863235 4.16967 0.836442 4.15766 0.816479C4.14721 0.800718 4.12736 0.791787 4.10961 0.787584C3.97589 0.760266 3.83904 0.745031 3.69593 0.745031C2.37969 0.745031 1.34602 1.99064 1.69858 3.3781C1.93624 4.31218 2.7965 4.93263 3.75495 4.90741ZM3.84819 5.73175C3.84976 5.73963 3.84663 5.75119 3.832 5.7596C3.47787 5.93559 2.11096 6.70103 2.28281 8.31492C2.29012 8.38532 2.23475 8.44521 2.16528 8.43523C1.82891 8.38689 0.96343 8.19987 0.694959 7.61725C0.546098 7.30887 0.546098 6.95163 0.694959 6.64324C0.870457 6.26762 1.29354 6.00914 1.93755 5.88201C2.24207 5.80793 3.06419 5.70286 3.82991 5.71704C3.8414 5.71862 3.84715 5.72703 3.84819 5.73175Z" fill="#6886AF"/>
                                        </svg>
                                        <span>{{matches.user_play}}</span>/{{matches.max_players}}
                                    </div>
<!--                                    <span class="circle"></span>-->
<!--                                    <p class="game-info-game__created">{{__('Multiplayer')}}</p>-->

                                  <div class="list-list" v-if="game.type == 3 && matches.users">
                                    <div  v-for="(user, key) in matches.users" :key="key" class="block-img " :class="(user.pro) ? 'user-pro-img' : ''">
                                      <router-link :to="{name: 'profile', params: {id: user.public_id, lang: $store.getters.getLang}}" >
                                        <div class="wrap-img img-muti-list">
                                          <img v-if="user.photo && typeof user.photo == 'object'" :src="user.photo[40]"/>
                                          <img v-else-if="user.photo" :src="user.photo"/>
                                          <span v-else class="photo" :style="{'background': user.bg_color}">{{user.name.substr(0,1)}}</span>
                                        </div>
                                      </router-link>
                                    </div>
                                  </div>
                                </div>
                                <div v-else class="block-info-game">
                                    <div class="block-info-game__players">
                                        <svg width="12" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.8182 2.00001V0.181824H10L6.50909 4.07273L7.85455 5.56364L11.8182 2.00001Z" fill="#6886AF"/>
                                            <path d="M0.181824 10.9091C0.181824 11.4182 0.581824 11.8182 1.09091 11.8182C1.67273 11.8182 2.1091 11.2728 1.96364 10.7273L3.78182 8.90912L5.23637 10.3637V9.27276L4.5091 8.54549L5.41819 7.74548L4.14546 6.58185L3.38182 7.41821L2.65455 6.69094H1.56364L3.01819 8.14548L1.20001 9.96367C0.690915 9.89094 0.181824 10.3273 0.181824 10.9091Z" fill="#6886AF"/>
                                            <path d="M6.72728 9.27273V10.3636L8.18182 8.9091L10 10.7273C9.89091 11.3091 10.3273 11.8182 10.8727 11.8182C11.3818 11.8182 11.7818 11.4182 11.7818 10.9091C11.7818 10.3636 11.2727 9.92728 10.6909 10L8.87273 8.18182L10.3273 6.72728H9.23637L8.5091 7.41819L2.00001 0.181824H0.181824V2.00001L7.45455 8.58182L6.72728 9.27273Z" fill="#6886AF"/>
                                        </svg>
                                        <p class="game-info-game__created">{{__('Battle 1 vs 1')}}</p>
                                    </div>
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <div class="wrapper-attributes" v-if="matches.attributes && matches.attributes.length">
<!--                    <GameAttributesItem v-for="(attributes, key) in matches.attributes" :key="key" v-bind:attribute="sortAttributes(attributes)"></GameAttributesItem>-->
                    <GameAttributesItem v-for="(attributes, key) in sortAttributes" :key="key" v-bind:attribute="attributes"></GameAttributesItem>
                </div>
                <div class="block-right">
                    <div class="block-money" v-if="game.type == 2 || game.type == 3 || game.type == 4">
                        <div class="wrap-icon">
                            <img v-if="(matches.wallet== 1)" class="pic" src="/dist/images/frontend/money.svg" alt/>
                            <img v-else class="pic" src="/dist/images/frontend/light-coin.svg" alt />
                        </div>

                        <span v-if="(matches.wallet== 1)" class="warning--text">{{formatNumber(primNum(matches.amount, 2))}}</span>
                        <span v-else class="block-money__lite">{{formatNumber(primNum(matches.amount, 2))}}</span>
                    </div>

                    <div class="block-money" v-else>
                        <div class="wrap-icon">
                            <img v-if="(matches.wallet== 1)" class="pic" src="/dist/images/frontend/money.svg" alt/>
                            <img v-else class="pic" src="/dist/images/frontend/light-coin.svg" alt />
                        </div>

                        <span v-if="(matches.wallet== 1)" class="warning--text">
                        <p>{{formatNumber(primNum(matches.amount_from, 2))}}</p>
                        <span class="line">-</span>
                        <p>{{formatNumber(primNum(matches.amount_to, 2))}}</p>
                    </span>
                        <span v-else class="block-money__lite">
                      <p>{{formatNumber(primNum(matches.amount_from, 2))}}</p>
                       <span class="line">-</span>
                      <p>{{formatNumber(primNum(matches.amount_to, 2))}}</p>
                    </span>
                    </div>


                    <!--            <v-btn v-if="auth" :loading="submitDisabled" v-ripple="{ class:'secondary&#45;&#45;text'}" text :class="(matches.wallet== 1) ? 'real-btn white&#45;&#45;text' : 'lite-btn white&#45;&#45;text'" @click="sendInvitation(((matches.user) ? matches.user.id : matches.user_id), matches.id)">-->
                    <!--                <img class="mr-2" src="/dist/images/frontend/create-btn.svg" alt="/" />-->
                    <!--                Play now-->
                    <!--            </v-btn>-->

                    <div class="wrap-btn">
                        <BaseButton
                            v-if="auth"
                            style="width: 100%"
                            :class_btn="(matches.wallet== 1) ? 'baseButton-game' : ''"
                            :loading="submitDisabled"
                            @click="playOn"
                        >
                              <span>
                                  <svg v-if="matches.password" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.8001 8.19996H2.60001C1.71635 8.19996 1 8.91631 1 9.79997V15.4C1 16.2837 1.71635 17 2.60001 17H13.8001C14.6837 17 15.4001 16.2837 15.4001 15.4V9.79997C15.4001 8.91631 14.6837 8.19996 13.8001 8.19996Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.19982 8.20003V5.00002C4.19982 3.93915 4.62125 2.92173 5.3714 2.17158C6.12155 1.42143 7.13897 1 8.19984 1C9.26071 1 10.2781 1.42143 11.0283 2.17158C11.7784 2.92173 12.1999 3.93915 12.1999 5.00002V8.20003" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>

                                 <img v-else src="/dist/images/frontend/create-btn.svg" alt="/" />
                                  <p>{{__('Play now')}}</p>
                              </span>
                        </BaseButton>
                        <v-tooltip v-else bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <BaseButton
                                    style="width: 100%"
                                    :loading="submitDisabled"
                                    :class_btn="(matches.wallet== 1) ? 'baseButton-game' : ''"
                                    v-on="on"
                                    v-bind="attrs"
                                    v-on:click="pushRegister"
                                >
                                  <span>
                                     <img src="/dist/images/frontend/create-btn.svg" alt="/" />
                                      <p>{{__('Play now')}}</p>
                                  </span>
                                </BaseButton>

                                <!--                            <v-btn-->
                                <!--                                    text-->
                                <!--                                    :class="(matches.wallet== 1) ? 'real-btn white&#45;&#45;text' : 'lite-btn white&#45;&#45;text'"-->
                                <!--                                    class="default not-create"-->
                                <!--                                    v-on="on"-->
                                <!--                                    v-bind="attrs"-->
                                <!--                                    v-on:click="$store.commit('updateModalAuth', 'register')"-->
                                <!--                            >-->
                                <!--                                <img class="mr-0" src="/dist/images/frontend/create-btn.svg" alt="/" />-->
                                <!--                                <p>Play now</p>-->
                                <!--                            </v-btn>-->
                            </template>
                            <span>{{__('You are not logged in')}}</span>
                        </v-tooltip>

<!--                        <v-btn-->
<!--                                v-if="matches.attributes && matches.attributes.length"-->
<!--                                @click="show = !show"-->
<!--                                class="btn-link"-->
<!--                                icon-->
<!--                                v-ripple="false"-->
<!--                        >-->
<!--                            <svg v-if="!show" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M12.8334 1.08331L7.00008 6.91665L1.16675 1.08331" stroke="#96AFD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->

<!--                            <svg v-else width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M1.16658 6.91669L6.99992 1.08335L12.8333 6.91669" stroke="#26A9F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->
<!--                        </v-btn>-->
                    </div>


                    <ModalDefault v-if="modal_cancel" v-bind:modal_cancel.sync="modal_cancel" :width="400">
                        <div class="modal-invite">
                            <div class="modal-invite__head">
                                <!--<p>{{(this.edit_bid) ? 'Edit match' : 'Create match'}}</p>-->
<!--                                <v-list>-->
                                    <v-list-item class="pa-0">
                                        <div class="wrap-img">
                                            <img v-if="typeof game.logo == 'object'" :src="game.logo[100]" />
                                            <img v-else :src="game.logo" />
                                        </div>
                                        <v-list-item-content>
                                            <div>
                                                <v-list-item-title>{{__('Send Invite')}}</v-list-item-title>
                                                <v-list-item-subtitle>{{game_array.name}}</v-list-item-subtitle>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
<!--                                </v-list>-->

                                <div class="wrap-slide" v-if="game.type == 1">
                                    <v-slider
                                        v-model="value"
                                        :max="matches.amount_to"
                                        :min="matches.amount_from"
                                        step="0.1"
                                    >
                                    </v-slider>
                                </div>
                            </div>
                            <div class="modal-invite__body">
                              <div v-if="game.type == 1">
                                <div class="wrapper-btn" v-if="matches.wallet== 1">
                                  <v-btn text v-ripple="false" @click="value = matches.amount_from" class="real-btn">
                                    <img height="16" src="/dist/images/frontend/money.svg" alt="">
                                    <span style="color: #FDAE02">{{matches.amount_from}}</span>
                                  </v-btn>

                                  <v-btn text v-ripple="false" @click="value = Number(Math.floor(matches.amount_to * 10) / 10)" class="real-btn" >
                                    <img height="16" src="/dist/images/frontend/money.svg" alt="">
                                    <!--                                        <span style="color: #FDAE02">{{matches.amount_to}}</span>-->
                                    <span style="color: #FDAE02">{{Number(Math.floor(matches.amount_to * 10) / 10)}}</span>
                                  </v-btn>
                                </div>


                                <div class="wrapper-btn" v-else>
                                  <v-btn text v-ripple="false"  @click="value = matches.amount_from" class="lite-btn">
                                    <img height="16" src="/dist/images/frontend/light-coin.svg" alt="">
                                    <span style="color: #607EA7">{{matches.amount_from}}</span>
                                  </v-btn>

                                  <v-btn text v-ripple="false"  @click="value = Number(Math.floor(matches.amount_to * 10) / 10)"  class="lite-btn">
                                    <img height="16" src="/dist/images/frontend/light-coin.svg" alt="">
                                    <!--                                        <span style="color: #607EA7">{{matches.amount_to}}</span>-->
                                    <span style="color: #607EA7">{{Number(Math.floor(matches.amount_to * 10) / 10)}}</span>
                                  </v-btn>
                                </div>
                              </div>
                                <div class="wrap-price" v-if="game.type == 1">
                                    <p class="wrap-price__title">{{__('Enter amount')}} ({{matches.amount_from + ' - ' + matches.amount_to}})</p>

                                    <div class="wrap-price__sum">
                                        <InputLabelTextDefault
                                                posLabel="right"
                                                type="number"
                                                min="1"
                                                color="border-norm"
                                                placeholder="0"
                                                v-model="amount"
                                                v-bind:errors="formValidate.amount"
                                                @change="upadateValue"
                                                @input="updateValidate('amount')"
                                        >


                                            <template v-slot:right>
                                                <div class="currency">
                                                <span v-if="matches.wallet== 1">
                                                  <img width="20px" src="/dist/images/frontend/money.svg" alt="">
                                                </span>
                                                    <span v-else-if="matches.wallet== 2">
                                                   <img width="20px" src="/dist/images/frontend/light-coin.svg" alt />
                                                </span>
                                                </div>
                                            </template>
                                        </InputLabelTextDefault>
                                    </div>
                                </div>

                                <div v-if="matches.password" class="wrap-price mt-5">
                                    <p class="wrap-price__title">{{__('Game password')}}</p>
                                    <InputLabelTextDefault
                                        type="password"
                                        switchType
                                        color="border-norm"
                                        v-model="password"
                                        v-bind:errors="formValidate.password"
                                        @input="updateValidate('password')"
                                    >
                                    </InputLabelTextDefault>
                                </div>

                                <div class="block-params" v-if="matches.attributes && matches.attributes.length">
                                    <div class="block-params__head">
                                        {{__('game options')}}
                                    </div>

                                    <div class="block-params__body">
                                         <div v-for="(item, key) in sortAttributes" :key="key" class="item-params">
                                             <span>{{item.attrName}}</span>
                                             <p>{{item.name}}</p>
                                         </div>
                                    </div>
                                </div>

                                <div class="wrap-btn">
                                    <BaseButton
                                            class="mr-4"
                                            class_btn="btn-liteGrey-quest"
                                            v-on:click="modal_cancel = false"
                                            width="120"
                                    >
                                        <span>{{__('Cancel')}}</span>
                                    </BaseButton>

                                    <BaseButton
                                            width="120"
                                            class_btn="btn-guest"
                                            v-on:click="sendInvitation(((matches.user) ? matches.user.id : matches.user_id), matches.id)"
                                            :loading="submitDisabled"
                                    >
                                        <span>{{__('Send Invite')}}</span>
                                    </BaseButton>
                                </div>
                            </div>
                        </div>
                    </ModalDefault>
                </div>
            </div>
            <ModalBunMatch
                v-if="modal_bun"
                v-bind:modal_bun.sync="modal_bun"
            ></ModalBunMatch>
        </div>
        <v-expand-transition >
            <div v-show="show">
                <v-card-text>
                    <div class="wrapper-attributes-bottom" v-if="matches.attributes && matches.attributes.length">
<!--                        <GameAttributesItem v-for="(attributes, key) in matches.attributes" :key="key" v-bind:attribute="sortAttributes(attributes)"></GameAttributesItem>-->
                        <GameAttributesItem v-for="(attributes, key) in sortAttributes" :key="key" v-bind:attribute="attributes"></GameAttributesItem>
                    </div>
                </v-card-text>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>

    import GameAttributesItem from '../pages/Games/GameAttributesItem';
    import ModalDefault from "../modules/ModalDefault";
    import moment from "moment";
    import {required, decimal, minValue, maxValue, maxLength, minLength} from "vuelidate/lib/validators";
    import InputLabelTextDefault from '../modules/InputLabelTextDefault';
    import _ from 'lodash';
    import ModalBunMatch from "../pages/Games/ModalBunMatch";

    export default {
        name: 'GameUserListItem',
        data: function() {
            return {
              userId: (this.matches.user) ? this.matches.user.id : this.matches.user_id,
              show: true,
              id: this.game.id,
              dialog: false,
              submitDisabled: false,
              now_date: moment.utc(new Date()).format('X'),
              date: (this.matches.user && this.matches.user.online) ? moment.utc(this.matches.user.online).format('X') : null,
              modal_cancel: false,
              amount: this.matches.amount_from ? this.matches.amount_from : null,
              value: this.matches.amount_from ? this.matches.amount_from : 0,
              formValidate: {
                  amount: null,
                  password: null,
              },
              modal_bun: false,
              password: null,
            }
        },

        validations() {
            return {
                amount: {
                    decimal,
                    required: (this.game.type == 1) ? required : true,
                    minValue: minValue(this.matches.amount_from),
                    maxValue: maxValue(this.matches.amount_to),
                },
                password: {
                    required: (this.matches.password) ? required : true,
                    minLength: minLength(4),
                    maxLength: maxLength(20),
                },
            }
        },
        props: {
            matches: {
                type: Object,
            },
            game: {
                type: Object
            },
            user: {
                type: Object
            },
            profile: {
                type: Object
            },
            item_game: {
                type: String,
            },
            class_list: {
              type: String,
              default: '',
            },
        },

        watch: {
            value(val) {
                this.amount = val;
            }
        },
        computed: {
            auth() {
                return this.$store.state.auth.user
            },
            lang() {
                return this.$store.state.language.lang;
            },
            game_array() {
                if (this.$filterArray(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, this.lang, 'lang')) {
                    return this.$filterArray(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, this.lang, 'lang');
                } else {
                    return this.$filterArray(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, 'en', 'lang');
                }
            },
            sortAttributes() {
                let gameAttr= this.$cleanObject(this.game.attributes);
                let attributes= this.$cleanObject(this.matches.attributes);
                let options= [];
                _.forEach(gameAttr, function (value) {
                    let attr= _.find(attributes, {key: value.key});
                    let option;
                    if(attr) {
                        option= _.find(value.options, {key: attr.option});
                        option.attrName = value.name;
                        if(option) {
                            options.push(option);
                        }
                    }
                });
                return options;

                /*let attributes,
                    option;

                for (let i = 0; i < this.game.attributes.length; i++) {
                    if (item.key == this.game.attributes[i].key) {
                        attributes = this.game.attributes[i];
                        break;
                    }
                }

                for (let i = 0; i < attributes.options.length; i++) {

                    if (item.option == attributes.options[i].key) {
                        option = attributes.options[i];

                        break;
                    }
                }
                return {attributes, option};*/
            },
            readyPlay() {
                return this.$store.getters.getReadyToPlay;
            },

            // sleepPlayer() {
            //     let status = '';
            //     let userId = (this.matches.user) ? this.matches.user.id : this.matches.user_id;
            //
            //     if (this.readyPlay[userId] && this.readyPlay[userId] == 1) {
            //         status = ' sleep'
            //     } else if (this.readyPlay[userId] && this.readyPlay[userId] == 2) {
            //         status = ' played'
            //     }
            //     console.log(status);
            //     return status
            // }
        },
        methods: {
            playOn() {
                if (this.$gtag) {
                    this.$gtag.event('PlayGame', { 'GameID': this.game.id });
                }

                if (this.$metrika) {
                    this.$metrika.reachGoal('PlayGame');
                }


                if((this.game.type == 2 || this.game.type == 3 || this.game.type == 4) && !this.matches.password) {
                    this.sendInvitation(((this.matches.user) ? this.matches.user.id : this.matches.user_id), this.matches.id)
                } else {
                    this.modal_cancel = true;
                }

            },
            pushRegister() {
                this.$store.commit('updateModalAuth', 'register');
                if (this.$gtag) {
                    this.$gtag.event('PlayGame', { 'GameID': this.game.id });
                }
                if (this.$metrika) {
                    this.$metrika.reachGoal('PlayGame');
                }
            },
            upadateValue() {
              this.value = this.amount;
            },

            sendInvitation(userId, match_id) {
                let matches= this.matches;

                let valid = this.$v;

                if (valid.$invalid) {
                    let massages = {
                        amount: [],
                        password: []
                    };
                    this.formValidate = this.$formValidate(massages, valid);
                } else {
                    const formData = {
                        match_id: match_id,
                        game_id: this.game.id,
                        user_id: userId,
                        amount: (this.game.type == 1) ? this.amount : this.primNum(matches.amount, 2),
                        wallet: matches.wallet,
                        password: this.password,
                    };

                    this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/games/play_on', formData)
                        .then(response=> {
                            return response.json()
                        })
                        .then((response)=> {
                            if(this.$checkAuth(response)) {
                                // response = {
                                //   "data": {
                                //     "match_id": 12345863,
                                //     "user_id": 4,
                                //     "session_id": "FAmXFZ8SKIAxMvOhmSPE6fyECYPsXgBqvlQpSK0W",
                                //     "game_id": 636316,
                                //     "game_name": "Gravity Defied Bike",
                                //     "game_logo": "/assets/games/game2048.png",
                                //     "wallet": 2,
                                //     "amount": "2.00",
                                //     "inviter_id": 2,
                                //     "timestamp": 1618568649,
                                //     "name": "Happy Proger",
                                //     "photo": "/assets/users/a-1609759324m90pBdwJSb.png",
                                //     "bg_color": "#f9851a",
                                //     "rating_points": 1079,
                                //     "vip": 0,
                                //     "location": "DZ",
                                //     "location_img": "/dist/images/flags/dz.png",
                                //       "game_translations": [
                                //           {
                                //               "description": "Bomberman Description",
                                //               "game_id": 632110,
                                //               "lang": "en",
                                //               "name": "Bomberman",
                                //               "rules": "Bomberman Game control"
                                //           },
                                //           {
                                //               "description": "Бомбермен описание",
                                //               "game_id": 632110,
                                //               "lang": "ru",
                                //               "name": "Бомбермен",
                                //               "rules": "Бомбермен &nbsp;Game control"
                                //           }
                                //       ],
                                //     "user": {
                                //       "bg_color": "#f84138",
                                //       "id": 1,
                                //       "last_name": "Volkonsky",
                                //       "location": "UA",
                                //       "location_img": "/dist/images/flags/ua.png",
                                //       "name": "Vladyslav",
                                //       "online": "2021/07/14 09:51:56",
                                //       "photo": "/assets/users/3.jpeg",
                                //       "public_id": "volkonsky",
                                //       "rating_points": "79159",
                                //       "session_id": "DsPELuwJ0wnQsTUfgHpHALkEKxdl7L1wtEeX2fJD",
                                //       "pro": "0",
                                //     },
                                //     "attributes": [
                                //       {
                                //         "img": "/assets/games/options/attr-1618509166NGttSYZKaJ.png",
                                //         "attr_name": "game speed",
                                //         "name": "Легкий",
                                //         "key": "lite",
                                //         "description": "Для нубов безпальцых",
                                //         "invalid": false
                                //       },
                                //       {
                                //         "img": "/assets/games/options/attr-1617201681aCBrGbGTKf.png",
                                //         "attr_name": "game speed",
                                //         "name": "1 мин",
                                //         "key": "1",
                                //         "description": "1 мин",
                                //         "invalid": false
                                //       },
                                //       {
                                //         "img": "/assets/games/options/attr-1618509166NGttSYZKaJ.png",
                                //         "name": "Легкий",
                                //         "key": "lite",
                                //         "description": "Для нубов безпальцых",
                                //         "invalid": false
                                //       },
                                //       {
                                //         "img": "/assets/games/options/attr-1617201681aCBrGbGTKf.png",
                                //         "attr_name": "game speed",
                                //         "name": "1 мин",
                                //         "key": "1",
                                //         "description": "1 мин",
                                //         "invalid": false
                                //       }
                                //     ]
                                //   },
                                //   "status": 200
                                // }

                                // response = {
                                //     "data": {
                                //         "success": false,
                                //         "msg": "the user has blocked invitations to the game"
                                //     },
                                //     "auth": true,
                                //     "status": 200
                                // }


                                // if ((this.game.type == 2 && this.game.type_user != 1) && this.game.developer.id != this.auth.id) {

                                this.modal_cancel = false;
                                response= response.data;


                                if (response.action)  {
                                    this.submitDisabled = false;
                                    if(response.action== 'start') {
                                        this.$store.dispatch("asyncInviteGame", []);
                                        this.$router.push({
                                            name: "frame",
                                            params: {
                                                id: response.game_url,
                                                room_id: response.room_id,
                                                battle_id: response.battle_id,
                                                lang: this.$store.getters.getLang
                                            },
                                        });
                                    } else {
                                        this.$store.dispatch("asyncInviteRoom", response);
                                    }
                                } else if (this.game.type == 2 || this.game.type == 4)  {
                                    this.submitDisabled = false;
                                    this.$router.push({
                                        name: "frame",
                                        params: {
                                            id: response.game_url,
                                            room_id: response.room_id,
                                            battle_id: response.battle_id,
                                            lang: this.$store.getters.getLang,
                                        },
                                    });
                                    this.$store.dispatch("asyncInviteRoom", null);
                                    this.$store.dispatch("asyncInviteGame", []);
                                } else if (this.game.type == 1 && response.msg) {
                                    this.modal_cancel = false;
                                    this.modal_bun = true;
                                } else {
                                    this.modal_cancel = false;
                                    this.amount =  this.matches.amount_from ? this.matches.amount_from : null,
                                    this.value = this.matches.amount_from ? this.matches.amount_from : 0,
                                    this.dialog = true;
                                    // this.$emit('update:invite', this.matches);
                                    this.matches.cancel= false;
                                    this.matches.timestamp= response.timestamp;
                                    this.$store.dispatch("asyncModalInvite", this.matches);
                                    this.$emit('data_invite', response);
                                }

                                if (this.$gtag) {
                                    this.$gtag.event('PlayGameDone', { 'GameID': this.game.id });
                                }
                                if (this.$metrika) {
                                    this.$metrika.reachGoal('PlayGameDone');
                                }
                            }
                        })
                        .catch((err) => {
                            this.httpHandler(err);
                        });

                    this.submitDisabled=true;
                    setTimeout(()=> {
                        this.submitDisabled= false;
                    }, 15000);
                }
            },
            updateValidate: function (type) {
                this.formValidate = this.$changeValidate(
                    this.formValidate,
                    this.$v[type],
                    type
                );
            },
        },
        mounted() {

        },

        components: {
            GameAttributesItem,
            ModalDefault,
            InputLabelTextDefault,
            ModalBunMatch
        },
    };
</script>

<style lang="scss" scoped>

    .dark .theme--light.v-card {
        background: #171827!important;
    }

    .dark .theme--light.v-sheet {
        border-color: #171827!important;
    }

    .dark .item_game {
        background: #171827!important;
    }

    .dark .user-list {
        background: transparent;

        .v-list-item {
            &__title {
                color: #fff;
                a,
                span {
                    color: #fff;
                }

                span {
                    cursor: default;
                }
            }
        }
    }

    .dark .v-sheet.v-card {
        border-radius: 0;
        border-bottom: 1px solid #2B2B2B!important;
    }

    .v-sheet.v-card:not(.v-sheet--outlined) {
        box-shadow: none;
    }

    .v-sheet.v-card {
        border-radius: 0;
        border-bottom: 1px solid #ECF4FF;
    }

    .v-card__text {
        padding: 0;
    }

.dark {
    .modal-invite {
        border-radius: 4px;
        background: #171827;
        &__head {
            background-color: #171827;

            .v-list-item {
                &__title {
                    color: #fff;
                }

                &__subtitle {
                    color: #96AFD1;
                }
            }
        }

        &__body {
            .wrap-price {
                &__title {
                    color: #96AFD1;
                }
            }

            .block-params {
                &__head {
                    color: #fff;
                    background: #171827;
                }

                &__body {
                    .item-params {
                        color: #fff;
                    }
                }
            }
        }
    }
}

.modal-invite {
    border-radius: 4px;
    &__head {
        /*display: flex;*/
        /*justify-content: space-between;*/
        /*align-items: center;*/
        background-color: #fff;
        border-radius: 8px 8px 0px 0px;
        padding: 10px 10px 0;
        position: relative;

        .wrap-slide {
            margin:0 2px 0;
            position: relative;

            &:after {
                content: '';
                position: absolute;
                left: -12px;
                top: 15px;
                width: 20px;
                height: 2px;
                background-color: #E0ECFD;
            }

            &:before {
                content: '';
                position: absolute;
                right: -12px;
                top: 15px;
                width: 20px;
                height: 2px;
                background-color: #E0ECFD;
            }


        }



            .v-list-item {
                display: flex;
                align-items: center;

                .wrap-img {
                    border-radius: 8px;
                    width: 40px;
                    height: 40px;
                    box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);

                    img {
                        border-radius: 8px;
                        width: 40px;
                        height: 40px;
                    }
                }

                &__content {
                    padding: 0;
                    margin-left: 8px;
                }

                &__title {
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 24px;
                    color: #000000;
                    margin-bottom: 1px;
                }

                &__subtitle {
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    color: #002B50;

                    span {
                        color: #002B50;
                    }
                }
            }

    }

    &__body {
        padding: 10px 20px 20px;

        .wrapper-btn {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }

        .v-btn.real-btn {
            height: 24px;
            background: #FFFFFF;
            border: 1px solid #FDAE02;
            box-shadow: 0 2px 5px rgba(51, 97, 255, 0.03);
            border-radius: 30px;
            padding: 0 5px;
            margin-right: 10px;
            font-size: 13px;
            line-height: 18px;
            transition: .3s;

            &:before {
                background-color: #fff;
            }

            &:hover {
                transform: scale(1.1);
                transition: .3s;
            }

            img {
                margin-right: 2px;
            }
        }

        .v-btn.lite-btn {
            height: 24px;
            background: #FFFFFF;
            border: 1px solid #96AFD1;
            box-shadow: 0 2px 5px rgba(51, 97, 255, 0.03);
            border-radius: 30px;
            padding: 0 5px;
            margin-right: 10px;
            font-size: 13px;
            line-height: 18px;
            transition: .3s;

            &:before {
                background-color: #fff;
            }

            &:hover {
                transform: scale(1.1);
                transition: .3s;
            }
            img {
                margin-right: 2px;
            }
        }

        .wrap-price {

            &__title {
                font-size: 14px;
                line-height: 12px;
                display: flex;
                align-items: center;
                color: #6886AF;
                opacity: 0.87;
                margin-bottom: 10px;
            }
        }
        .currency {
            display: flex;
            align-items: center;

            img {
                margin-bottom: 2px;
            }
        }

        .block-params {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            width: 100%;
            cursor: default;

            &:after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 9px;
                width: 100%;
                height: 1px;
                background: linear-gradient(90deg, rgba(0, 174, 255, 0) 0%, rgba(0, 174, 255, 0.6) 36.16%, rgba(0, 174, 255, 0.6) 67.61%, rgba(0, 174, 255, 0) 100.62%);
            }


            &__head {
                background: #fff;
                padding: 1px 6px 1px;
                border: 1px solid #00AEFF;
                box-sizing: border-box;
                border-radius: 4px;
                font-weight: 500;
                font-size: 10px;
                line-height: 14px;
                color: #002B50;
                text-transform: uppercase;
                margin-bottom: 10px;
                position: relative;
                z-index: 10;
            }

            &__body {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;

                .item-params {
                    padding: 6px 12px;
                    display: flex;
                    align-items: center;
                    background: rgba(0, 174, 255, 0.1);
                    border-radius: 5px;
                    margin: 4px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 19px;
                    display: flex;
                    align-items: center;
                    color: #002B50;

                    span {
                        margin-right: 6px;
                        text-transform: capitalize;
                    }

                    p {
                        margin: 0;
                        color: #00AEFF;
                    }
                }
            }
        }

        .wrap-btn {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;

            div {
                width: 50%;
            }
        }
    }
}

.user-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:5px 12px 5px 5px;
  /*border-bottom: 2px solid #ECF4FF;*/
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 38.42%, rgba(255, 255, 255, 0.5) 99.34%);
  border-radius: 8px;
  margin-bottom: 10px;

  .block-played {
      display: none;
  }

  .block-sleeped {
      display: none;
  }

  .button-sleepped {
    display: none;
  }

  .button-played {
    display: none;
  }

  .v-list-item {

    &__content {
      display: block;
    }

    &__title {
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      text-transform: capitalize;
      color: #002B50;
      margin-bottom:3px;
      max-width: 170px;
      min-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

        a {
            text-decoration: none;
            color: #002B50;

            &:hover {
                text-decoration: underline;
                color: #4EBEFF;
            }
        }
    }

    &__subtitle {
      font-size: 12px;
      line-height: 16px;
      max-width: 170px;
      min-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      align-items: center;

        .block-raiting {
            margin-right: 10px;
            img {
                margin-bottom: 3px;
            }
        }

        .block-info-game {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 13px;
            line-height: 18px;
            color: #6886AF;

            &__players {
                margin-right: 7px;
                display: flex;
                align-items: center;
                svg {
                    margin-right: 4px;
                }

                span {
                    color: #26A9F4;
                    font-weight: bold;
                }
            }

            p {
                margin: 0;

                span {
                    color: #26A9F4;
                    margin-left: 1px;
                }
            }

            .circle {
                display: block;
                min-width: 5px;
                min-height: 5px;
                border-radius: 50%;
                background-color: #CBDAE9;
                margin-right: 7px;
            }

            &__created {
                margin: 0;
            }
            a {
                color: #26A9F4;
                text-decoration: none;
                transition-duration: .3s;

                &:hover {
                    text-decoration: underline;
                    transition-duration: .3s;
                }
            }
        }
    }
  }
}

.dark {
    .games-card {
        .online {
            border: 2px solid #202020;
        }
    }
}

.games-card {
  /*border-bottom: 1px solid #ECF4FF;*/

    .online {
        border: 2px solid #fff;
        border-radius: 50%;
        background-color: #00C569;
        width: 10px;
        height: 10px;
        position: absolute;
        right: 0;
        bottom: 2px;
    }
}

.games-card.sleep {
    position: relative;

    .online {
        background: #96AFD1;
    }
}

.games-card.played {
    position: relative;

    .online {
        background: #FDAE02;
    }
}

.list-profile {
  /*border-bottom: 2px solid #ECF4FF;*/
  /*margin-left: 0;*/
  //margin-right: 7px;
    margin-bottom: 0;

  .user-list {
    padding: 10px 10px 10px 10px;
    margin-bottom: 0;
  }
}

.dark {
    .games-card.sleep {
        .user-list.item_game {
            .button-sleepped {
                background: #171827;
                border: 1px solid #4C4C4C;

                p {
                    color: #4C4C4C;
                }

                svg {
                    color: #4D4D4D;
                }
            }
        }
    }
}

.games-card.sleep {
    .user-list.item_game {
        &:hover {
            .block-sleeped {
                opacity: 1;
                transition-duration: .3s;
            }
        }

        .button-sleepped {
            z-index: 20;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            border-radius: 40px;
            background: #fff;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 18px;
            height: 42px;
            width: 172px;
            cursor: default;
            border: 1px solid rgba(150, 175, 209, 0.7);

            svg {
                margin-right: 12px;
                color: rgba(150, 175, 209, 0.7);
            }

            p {
                margin: 0;
                font-size: 14px;
                line-height: 19px;
                color: rgba(150, 175, 209, 0.7);
            }
        }
    }
}

.dark {
    .games-card.played {
        .user-list.item_game {
            .button-played {
                background: #171827;
                border: 1px solid rgba(253, 174, 2, 0.5);

                p {
                    color: rgba(253, 174, 2, 0.5);
                }

                svg {
                    color: rgba(253, 174, 2, 0.5);
                }
            }
        }
    }
}

.games-card.played {
    .user-list.item_game {
        &:hover {
            .block-played {
                opacity: 1;
                transition-duration: .3s;
            }
        }

        .button-played {
            z-index: 20;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            border-radius: 40px;
            background: #fff;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 18px;
            height: 42px;
            width: 172px;
            cursor: default;
            border: 1px solid rgba(253, 174, 2, 0.5);

            svg {
                margin-right: 12px;
                color: rgba(253, 174, 2, 0.5);
            }

            p {
                margin: 0;
                font-size: 14px;
                line-height: 19px;
                color: rgba(253, 174, 2, 0.5);
            }
        }
    }
}

.dark {
    .item_game {
        .block-sleeped,
        .block-played {
            background: #fff;
        }
    }
}

.item_game {
    border-radius: 8px;
    background-color: #fff;
    //border-bottom: 1px solid #ECF4FF;
    margin-bottom: 0;
    padding: 6px 20px 6px 20px;
    position: relative;

    .block-sleeped {
        display: flex;
        background: #171827;
        backdrop-filter: blur(5px);
        border-radius: 0 20px 20px 0;
        padding: 2px 14px 2px 30px;
        font-size: 12px;
        line-height: 16px;
        color: #96AFD1;
        position: absolute;
        bottom: 10px;
        left: 30px;
        z-index: 10;
        opacity: 0;
        transition-duration: .3s;
    }

    .block-played {
        display: flex;
        background: #171827;
        backdrop-filter: blur(5px);
        border-radius: 0 20px 20px 0;
        padding: 2px 14px 2px 30px;
        font-size: 12px;
        line-height: 16px;
        text-transform: capitalize;
        color: #FDAE02;
        white-space: nowrap;
        position: absolute;
        bottom: 10px;
        left: 30px;
        z-index: 10;
        opacity: 0;
    }
}

.block-img {
  margin-right: 10px;
  position: relative;
  z-index: 11;

    a {
        text-decoration: none;
    }

    .wrap-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;

        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }

    .photo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        color: #FFFFFF;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
        text-decoration: none;
    }
}

.block-img-game {
    margin-right: 10px;
    position: relative;

    .wrap-img-game {
        width: 54px;
        height: 54px;
        border-radius: 8px;
        box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);

        img {
            width: 54px;
            height: 54px;
            border-radius: 8px;
        }
    }
}

.rating {
    span {
        margin-right: 6px;
        margin-top: 3px;
        /*font-weight: bold;*/
        font-size: 14px;
        line-height: 22px;
        letter-spacing: -0.408px;
        color: #96afd1;
    }

    .v-rating {
        margin-top: 2px;

        .v-rating--dense .v-icon {
            padding: 0;
        }
    }

    a {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #26a9f4;
        text-decoration: none;
        margin-top: 7px;

        &:hover {
            text-decoration: underline;
        }
    }
}

.wrapper-attributes {
    margin: -4px 0 0 45px;
    width: 100%;
    /*min-height: 40px;*/
    height: 100%;
    display: flex;
    align-content: space-between;
    flex-wrap: wrap;

    /*.attributes-item {
        position: relative;
        display: flex;
        align-items: center;
        color: #6886AF;
        width: 33%;
        min-width: 60px;


        &__name {
            cursor: pointer;
            transition-duration: .3s;

            &:hover {
                color: #002B50;
                transition-duration: .3s;

                & ~.block-info-option {
                    opacity: 1;
                    display: flex;
                    transition-duration: .3s;
                }
            }
        }



        !*&:nth-child(3),*!
        !*&:nth-child(6){*!
        !*    margin-right: 0;*!
        !*}*!

        p {
            font-weight: 400;
            font-size: 13px;
            line-height: 18px;
            max-width: 150px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        i {
            font-size: 7px;
            display: flex;
            align-items: center;
            margin: 1px 6px 0 0;
        }

        .block-info-option {
            position: absolute;
            bottom: -85px;
            left: -50px;
            opacity: 0;
            display: none;
            transition-duration: .3s;
            width: 380px;
            !*width: 100%;*!
            z-index: 10;
            padding: 10px;
            background-color: #FFFFFF;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
            border-radius: 8px;


            img {
                width: 60px;
                height: 60px;
                border-radius: 6px;
                margin-right: 9px;
            }

            h5 {
                font-weight: 400;
                font-size: 14px;
                line-height: 14px;
                color: #002B50;
                margin-bottom: -2px;
            }

            span {
                max-width: 200px;
                width: 100%;
                font-weight: 400;
                font-size: 12px;
                line-height: 14px;
                color: #6886AF;
            }
        }
    }*/
}

.dark {
    .wrapper-attributes-bottom {
        background: #171827;
        border-bottom: 1px solid #363636;
    }
}

.wrapper-attributes-bottom {
    display: none;
    align-content: space-between;
    flex-wrap: wrap;
    overflow: hidden;
    margin: 0 -1px;
    background-color: #F3F7FE;
    border-bottom: 1px solid #ECF4FF;

}

.success-inner {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    border: 1px solid #00C443;
    box-sizing: border-box;
    border-radius: 8px;
    text-transform: inherit;
    color: #00C443;
    transition-duration: .3s;

    .pic {
        height:12px;
        margin: 0 1px 0 4px;
    }

    &:hover {
       border: 2px solid #00AD3B;
    }
}

.default-inner {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    border: 1px solid #6886AF;
    box-sizing: border-box;
    border-radius: 8px;
    text-transform: inherit;
    color: #6886AF;
    transition-duration: .3s;

    .pic {
        height:12px;
        margin: 0 1px 0 4px;
    }

     &:hover {
        border: 2px solid #96AFD1;
    }
}

.v-btn.not-create {

    &.v-btn:not(.v-btn--round).v-size--default {
        height: 40px;
        min-width: 140px;
        // width: 124px;
        padding: 10px;
        border-radius: 20px;
        margin: 0;
    }

    p {
        margin: 0 0 0 8px;
    }
}

.block-right {
    display: flex;
    align-items: center;
    white-space: nowrap;

    .wrap-btn {
        display: flex;
        align-items: center;
        width: 170px;
        justify-content: flex-end;

        .v-btn.btn-link {
            /*margin-left: 10px;*/
            display: none;
            position: absolute;
            z-index: 10;
            bottom: -5px;
            left: calc(50% - 18px);
            height: 24px;
        }
    }
}
    .dark .block-money {
        &__lite {
            color: #96AFD1;
        }
    }
.block-money {
    display: flex;
    align-items: center;

    &__lite {
        color: #6886af;
    }

    .wrap-icon {
        width: 58px;
        display: flex;
        justify-content: center;

        img {
            height: 18px;
        }
    }

    span {
        display: flex;
        width: 160px;
        justify-content: center;
        align-items: center;

        .line {
            width: fit-content;
            margin: 0 5px;
        }

        p {
            margin: 0;
            width: 70px;
            text-align: center;
        }
    }


}

    /*.lite-btn {*/
        /*background-color: #96AFD1;*/
        /*transition-duration: 0.3s;*/
        /*outline: none;*/

        /*&:hover {*/
            /*background-color: #819BBF;*/
        /*}*/
    /*}*/

    /*.real-btn {*/
        /*background-color: #4EBEFF;*/
        /*transition-duration: .3s;*/
        /*outline: none;*/

        /*&:hover {*/
            /*background-color: #26A9F4;*/
        /*}*/
    /*}*/


@media screen and (max-width: 1600px) {
  .wrapper-attributes {
    margin: 0;

  }
}


@media screen and (max-width: 1250px) {
    .v-btn.not-create {

        &.v-btn:not(.v-btn--round).v-size--default {
            height: 40px;
            min-width: 65px;
            padding: 10px;
            border-radius: 20px;
            margin: 0;
        }

        p {
            display: none;
        }
    }

    .user-list {

        .v-list-item {

            &__avatar {
                /*min-width: 45px;*/
            }

            &__title {
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                text-transform: capitalize;
                color: #002B50;
                max-width: 120px;
                min-width: 120px;
                margin-right: 10px;
            }

            &__subtitle {
                font-size: 12px;
                line-height: 16px;
                max-width: 120px;
                min-width: 120px;
            }
        }
    }

    /*.block-img {*/

    /*    .wrap-img {*/
    /*        width: 45px;*/
    /*        height: 45px;*/
    /*        border-radius: 50%;*/

    /*        img {*/
    /*            width: 45px;*/
    /*            height: 45px;*/
    /*            border-radius: 50%;*/
    /*        }*/
    /*    }*/

    /*    .photo {*/
    /*        width: 45px;*/
    /*        height: 45px;*/
    /*        border-radius: 50%;*/
    /*    }*/
    /*}*/
}

@media screen and (max-width: 1200px) {

    .block-money {

        .wrap-icon {
            width: 40px;
        }
    }

    .block-right {
        .wrap-btn {
            width: 150px;
        }
    }
}

@media screen and (max-width: 1100px) {
    .item_game {
        padding: 6px 10px 6px 10px;
    }

    .wrapper-attributes {
        display: none;
    }
    .wrapper-attributes-bottom {
        display: flex;
        padding: 6px 12px;
    }

    .block-right {
        .wrap-btn {
            width: fit-content;
            margin-left: 10px;

            .v-btn.btn-link {
                display: block;
            }
        }
    }

    .games-card.sleep {
        .user-list.item_game {
            .button-sleepped {
                right: 9px;
            }
        }
    }

    .games-card.played {
        .user-list.item_game {
            .button-played {
                right: 9px;
            }
        }
    }
}


/*@media screen and (max-width: 800px) {*/

  /*.online {*/
    /*right: 4px;*/
    /*bottom: 0px;*/
  /*}*/


  /*.user-list {*/

      /*.v-list-item {*/

          /*&__avatar {*/
              /*min-width: 45px;*/
          /*}*/

          /*&__title {*/
              /*font-weight: 400;*/
              /*font-size: 14px;*/
              /*line-height: 19px;*/
              /*text-transform: capitalize;*/
              /*color: #002B50;*/
              /*margin-bottom:3px;*/
          /*}*/

          /*&__subtitle {*/
              /*font-size: 12px;*/
              /*line-height: 16px;*/
          /*}*/
      /*}*/
  /*}*/

  /*.block-img {*/

      /*.wrap-img {*/
          /*width: 45px;*/
          /*height: 45px;*/
          /*border-radius: 50%;*/

          /*img {*/
              /*width: 45px;*/
              /*height: 45px;*/
              /*border-radius: 50%;*/
          /*}*/
      /*}*/

      /*.photo {*/
        /*width: 45px;*/
        /*height: 45px;*/
        /*border-radius: 50%;*/
      /*}*/
  /*}*/


  /*.block-money {*/
      /*span {*/
        /*font-size: 14px;*/
      /*}*/
      /*img {*/
          /*height: 12px;*/
      /*}*/
      /*.v-btn {*/
          /*font-size: 12px;*/
          /*margin-left: 30px;*/
      /*}*/
  /*}*/

  /*.v-btn:not(.v-btn--round).v-size--default {*/
      /*height: 36px;*/
      /*min-width: 120px;*/
      /*// width: 124px;*/
      /*padding: 10px;*/
  /*}*/
/*}*/

@media screen and (max-width: 768px) {
    .user-list {

        .v-list-item {

            &__avatar {
                min-width: 45px;
            }

            &__title {
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                text-transform: capitalize;
                color: #002B50;
                max-width: 170px;
                min-width: 170px;
                margin-right: 10px;
            }

            &__subtitle {
                font-size: 12px;
                line-height: 16px;
                max-width: 170px;
                min-width: 170px;
            }
        }
    }
}

/*@media screen and (max-width: 525px) {*/

    /*.user-list {*/
        /*padding: 5px 10px;*/

        /*.block-money {*/
            /*span {*/
                /*font-size: 10px;*/
            /*}*/

            /*img {*/
                /*height: 8px;*/
            /*}*/

            /*.v-btn {*/
                /*font-size: 8px;*/
                /*margin-left: 15px;*/
                /*border-radius: 6px;*/
            /*}*/
        /*}*/
        /*.v-btn:not(.v-btn--round).v-size--default {*/
            /*height: 30px;*/
            /*min-width: 90px;*/
            /*// width: 124px;*/
            /*padding: 10px;*/
        /*}*/

        /*.v-list-item {*/

            /*&__avatar {*/
                /*min-width: 45px;*/
            /*}*/

            /*&__title {*/
                /*font-weight: 400;*/
                /*font-size: 10px;*/
                /*line-height: 19px;*/
                /*text-transform: capitalize;*/
                /*color: #002B50;*/
                /*margin-bottom:0px;*/
            /*}*/

            /*&__subtitle {*/
                /*font-size: 8px;*/
                /*line-height: 16px;*/

                /*img {*/
                    /*height: 6px;*/
                    /*max-width: 10px;*/
                /*}*/
            /*}*/
        /*}*/

        /*.block-img {*/
            /*margin-right: 5px;*/
            /*.wrap-img {*/
                /*width: 38px;*/
                /*height: 38px;*/
                /*border-radius: 50%;*/

                /*img {*/
                    /*width: 38px;*/
                    /*height: 38px;*/
                    /*border-radius: 50%;*/
                /*}*/
            /*}*/
        /*}*/
    /*}*/
/*}*/

@media screen and (max-width: 650px) {

    .block-right .wrap-btn {
        width: 65px;
        .baseButton {
            min-width: 65px!important;
            width: 65px!important;
            span {
                svg,
                img {
                    margin-right: 0;
                }
                p {
                    display: none;
                }
            }
        }
    }
    .block-money {
        span {
            flex-direction: column;
            width: 64px;
            align-items: flex-start;

            p {
                font-size: 14px;
                line-height: 20px;
                text-align: left;
                width: 64px;
            }

            .line {
                display: none;
            }
        }
    }

    .block-img-game {
        margin-right: 10px;
        position: relative;

        .wrap-img-game {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);

            img {
                width: 40px;
                height: 40px;
                border-radius: 4px;
            }
        }
    }

    .user-list {

        .v-list-item {

            &__avatar {
                /*min-width: 45px;*/
            }

            &__title {
                font-weight: 400;
                font-size: 13px;
                line-height: 17px;
                text-transform: capitalize;
                color: #002B50;
                max-width: 150px;
                min-width: 150px;
                margin-right: 10px;
            }

            &__subtitle {
                font-size: 11px;
                line-height: 14px;
                max-width: 150px;
                min-width: 150px;

                .block-info-game {
                    font-size: 11px;
                    line-height: 14px;
                }
            }
        }
    }

    .games-card.sleep {
        .user-list.item_game {
            .button-sleepped {
                width: 66px;

                p {
                    display: none;
                }

                svg {
                    margin-right: 0;
                }
            }
        }
    }

    .games-card.played {
        .user-list.item_game {
            .button-played {
                width: 66px;

                p {
                    display: none;
                }

                svg {
                    margin-right: 0;
                }
            }
        }
    }
}

@media screen and (max-width: 450px) {
    .user-list {
        padding: 10px;

        .v-list-item {

            &__title {
                max-width: 110px;
                min-width: 110px;
                margin-right: 5px;
            }

            &__subtitle {
                max-width: 110px;
                min-width: 110px;

                .block-info-game {

                    &__players {
                        margin-right: 3px;
                    }
                    .circle {
                        margin-right: 3px;
                    }
                }
            }
        }

        .block-money {

            .wrap-icon {
                width: 30px;
                img {
                    height: 16px;
                }
            }
            span {
                flex-direction: column;
                width: 58px;

                .line {
                    display: none;
                }

                p {
                    width: 58px;
                    font-size: 12px;
                    line-height: 18px;
                    text-align: left;
                }
            }
        }
    }

    .item_game {
        .block-sleeped,
        .block-played {
            bottom: 15px;
        }
    }

    .games-card.sleep {
        .user-list.item_game {
            .button-sleepped {
                /*top: 11px;*/
            }
        }
    }

    .games-card.played {
        .user-list.item_game {
            .button-played {
                /*top: 11px;*/
            }
        }
    }

    .modal-invite {
        &__body {
            .block-params {
                margin: 14px 0;

                &__body {
                    .item-params {
                        padding: 4px 10px;
                        font-size: 12px;
                        line-height: 16px;
                    }
                }
            }
        }
    }
}

</style>